// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MuiDataGrid-columnHeaderRow .rejected-tab-data-grid {
  background-color: black;
}

.table-history-DateRejected-cell {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-left: 10px !important;
  font-size: 13px !important;
}

.table-history-userEmailRejected-cell {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 13px !important;
}

.table-history-userEmailJoined-cell {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
}

.date-rejected-table-header {
  padding-left: 1px !important;
}

.history-tab-totalCount-header {
  padding-left: 18px !important;
}

.history-tab-totalCount-header-approver-view {
  padding-left: 48px !important;
}

.date-joined-table-header {
  padding-left: 1px !important;
}

.history-tab-joinedDate-cell {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  font-size: 13px !important;
}
`, "",{"version":3,"sources":["webpack://./src/pages/OrgHistory/components/TabStyles.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,0BAA0B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;;EAEvB,0BAA0B;AAC5B","sourcesContent":[".MuiDataGrid-columnHeaderRow .rejected-tab-data-grid {\n  background-color: black;\n}\n\n.table-history-DateRejected-cell {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  padding-left: 10px !important;\n  font-size: 13px !important;\n}\n\n.table-history-userEmailRejected-cell {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    font-size: 13px !important;\n}\n\n.table-history-userEmailJoined-cell {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-size: 14px;\n}\n\n.date-rejected-table-header {\n  padding-left: 1px !important;\n}\n\n.history-tab-totalCount-header {\n  padding-left: 18px !important;\n}\n\n.history-tab-totalCount-header-approver-view {\n  padding-left: 48px !important;\n}\n\n.date-joined-table-header {\n  padding-left: 1px !important;\n}\n\n.history-tab-joinedDate-cell {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n\n  font-size: 13px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
